import { render, staticRenderFns } from "./kdProblemDes.vue?vue&type=template&id=0714d976&scoped=true"
import script from "./kdProblemDes.vue?vue&type=script&lang=js"
export * from "./kdProblemDes.vue?vue&type=script&lang=js"
import style0 from "./kdProblemDes.vue?vue&type=style&index=0&id=0714d976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0714d976",
  null
  
)

export default component.exports